const FeesStructure = () => {
    return (
        <div id="fees" className="vision-card">
            <h3>FEES STRUCTURE</h3>

            <div className="table-section-wrap">
                <table className="table-section">
                    <thead>
                        <tr>
                            <th>CLASS</th>
                            <th>ADMISSION FEE (IN RUPEES)</th>
                            <th>TUITION FEE (IN RUPEES)</th>
                            <th>YEARL Y DEVELOPMENT CHARGES (IN RUPEES)</th>
                            <th>ANNUAL/MONTHL Y OTHER CHARGES FOR OTHER FACILITIES (IN RUPEES)</th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>PRIMARY</td>
                            <td>3000</td>
                            <td>2450</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>

                        <tr>
                            <td>MIDDLE</td>
                            <td>3500</td>
                            <td>1300</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>

                        <tr>
                            <td>SECONDARY</td>
                            <td>4000</td>
                            <td>3400</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>

                        <tr>
                            <td>SENIOR SECONDARY</td>
                            <td>6000</td>
                            <td>4150</td>
                            <td>0</td>
                            <td>0</td>
                        </tr>

                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default FeesStructure;